import { render } from "./NotificationArea.vue?vue&type=template&id=49553168&scoped=true"
import script from "./NotificationArea.vue?vue&type=script&lang=js"
export * from "./NotificationArea.vue?vue&type=script&lang=js"

import "./NotificationArea.vue?vue&type=style&index=0&id=49553168&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3809301774/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49553168"]])

export default __exports__